

import { fetchInvestementPage } from "../../services/api";
import { useEffect, useState, useRef } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";


const MissionStrategic = ({ lang }) => {
  const [content, setContent] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);

  const webRef = useRef(null);
  const blockchainRef = useRef(null);
  const webContainerRef = useRef(null);
  const blockchainContainerRef = useRef(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > 1024);
    const handleResize = () => setIsDesktop(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setContent(null);

    const loadData = async () => {
      try {
        const enData = await fetchInvestementPage("en");

        if (lang !== "en") {
          const localData = await fetchInvestementPage(lang);
          const hasLocalData =
            localData &&
            !Array.isArray(localData) &&
            Object.keys(localData).length > 0;
          setContent(hasLocalData ? { ...enData, ...localData } : enData);
        } else {
          setContent(enData);
        }
      } catch {
        const fallback = await fetchInvestementPage("en");
        setContent(fallback);
      }
    };

    loadData();
  }, [lang]);

  useEffect(() => {
    if (isDesktop) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === webContainerRef.current) {
            if (entry.isIntersecting) webRef.current?.play();
            else webRef.current?.stop();
          }
          if (entry.target === blockchainContainerRef.current) {
            if (entry.isIntersecting) blockchainRef.current?.play();
            else blockchainRef.current?.stop();
          }
        });
      },
      { threshold: 0.4 }
    );

    if (webContainerRef.current) observer.observe(webContainerRef.current);
    if (blockchainContainerRef.current) observer.observe(blockchainContainerRef.current);

    return () => observer.disconnect();
  }, [isDesktop, content]);

  if (!content) return <div>Loading...</div>;

  return (
    <div className="md:flex">

      {/* Mission */}
      <div
        className="md:w-[50%] padding-x-40 padding-y-80 relative"
        ref={webContainerRef}
        onMouseEnter={() => isDesktop && webRef.current?.play()}
        onMouseLeave={() => isDesktop && webRef.current?.stop()}
      >
        <div className="section-name-wrapper">
          <div className="section-name-dot"></div>
          <h6 className="section-name">{content.Our_Mission_Section_Name}</h6>
        </div>
        <div className="mission-gif" style={{ alignItems: "center" }}>
          <DotLottieReact
            src="/lottie-files/Mission.lottie"
            loop
            autoplay={false}
            dotLottieRefCallback={(ref) => (webRef.current = ref)}
              renderConfig={{
    devicePixelRatio: window.devicePixelRatio || 2,
  }}
          />
        </div>
        <h4 className="size-h3 pt-5 text-dark-blue-color">
          {content.Our_Mission_Heading}
        </h4>
        <p className="fs-large text-dark-blue-color">
          {content.Our_Mission_Description}
        </p>
      </div>

      {/* Strategic Intent */}
        <div
          className="md:w-[50%] strategic-section"
          style={{ backgroundColor: "rgba(0, 64, 152, 1)" }}
        >
        
            <div
    className="relative overflow-hidden h-full w-full"
    style={{ backgroundColor: "rgba(0, 64, 152, 1)" }}
  >
    {/* Full section lottie */}
  <div className="absolute inset-0 z-0 overflow-hidden">
  <DotLottieReact className="respo-strategic-lottie"
    src="/lottie-files/Strategic Intent.lottie"
    loop
    autoplay={false}
    dotLottieRefCallback={(ref) => (blockchainRef.current = ref)}
    style={{
     
    }}
  />
</div>
  <div
            className="padding-x-40 padding-y-80 relative h-full"
            style={{ zIndex: "1", overflowX: "hidden" }}
            ref={blockchainContainerRef}
            onMouseEnter={() => isDesktop && blockchainRef.current?.play()}
            onMouseLeave={() => isDesktop && blockchainRef.current?.stop()}
          >
            <div className="section-name-wrapper">
              <div className="section-name-dot"></div>
              <h6 className="section-name text-light-blue">
                {content.Our_Strategic_Intent_Section_Name}
              </h6>
            </div>
            <h4 className="size-h3 text-light-blue pt-5">
              {content.Our_Strategic_Content_Heading}
            </h4>
          
          </div>
        </div>
    </div>
    </div>
  );
};

export default MissionStrategic;